import { render, staticRenderFns } from "./goldenyears.vue?vue&type=template&id=855802d6&scoped=true&"
import script from "./goldenyears.vue?vue&type=script&lang=js&"
export * from "./goldenyears.vue?vue&type=script&lang=js&"
import style0 from "./goldenyears.vue?vue&type=style&index=0&id=855802d6&scoped=true&lang=less&"
import style1 from "./goldenyears.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855802d6",
  null
  
)

export default component.exports